import { theme } from 'bs-unified-ui'
import { COLORS } from '~/themes/common'

const style = {
  quillContainer: {
    '& .ql-toolbar': {
      borderRadius: '5px 5px 0 0',
      border: '0.25px solid',
      paddingTop: 6,
      paddingBottom: 6,
    },
    '& .ql-toolbar.ql-snow': {
      padding: 4,
      borderColor: theme.background.outlineDivider,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& .ql-formats:last-child': {
        marginLeft: 'auto',
      },
    },
    '& .ql-import': {
      height: 'unset',
      width: 'unset !important',
      marginTop: -4,
    },
    '& .ql-container': {
      borderRadius: '0 0 5px 5px',
      backgroundColor: theme.background.white,
      borderColor: `${theme.background.outlineDivider} !important`,
      border: '0.25px solid',
    },
    '& .ql-editor': {
      minHeight: 120,
      fontSize: 14,
    },
  },
  error: {
    '& .ql-toolbar': {
      borderColor: '#E05069',
      borderWidth: '1.5px',
    },
    '& .ql-container': {
      borderColor: '#E05069',
      borderWidth: '1.5px',
    },
  },
  disabled: {
    userSelect: 'none',
    pointerEvents: 'none',
    cursor: 'not-allowed',
    '& .ql-toolbar': {
      borderColor: COLORS.gray.disableGray,
      borderBottom: 'none',
    },
    '& .ql-container': {
      borderColor: COLORS.gray.disableGray,
      backgroundColor: COLORS.gray.disableGray2,
    },
  },
  switchContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 8,
    position: 'absolute',
    right: 0,
    top: -30,
  },
  formLabel: {
    textAlign: 'left',
    fontSize: 14,
    letterSpacing: 0,
    color: COLORS.palette.black,
    opacity: 1,
    padding: '4px 0 0 0',
  },
  textArea: {
    flex: 1,
    minHeight: 140,
    width: 'calc(100% - 28px)',
    resize: 'none',
    backgroundColor: theme.background.white,
    padding: '10px 14px',
    fontSize: 14,
    fontFamily: 'Rubik',
    marginRight: 10,
    borderRadius: 5,
    border: `0.25px solid ${theme.background.outlineDivider}`,
    '&:focus': {
      outline: 'none',
    },
    '&::placeholder': {
      fontFamily: 'Rubik',
      color: COLORS.gray.textGray2,
      fontWeight: 300,
    },
    '&::-webkit-scrollbar': {
      width: 5,
      height: 5,
    },
    '&::-webkit-scrollbar-track': {
      borderRadius: 10,
      backgroundColor: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 10,
      backgroundColor: '#b4bfd9',
    },
  },
}

export default style
